import { useNavigate } from 'react-router-dom'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useUnsafeEffect } from 'modules/core/hooks/useEffect'
import { useNavigation } from 'modules/core/hooks/useNavigation'

import UpgradeModal from 'modules/billing/components/UpgradeModal'
import { planToUpgrade } from 'modules/billing/lib/utils'
import { subscriptionPlan } from 'modules/billing/store/collections/plans'
import subscriptions from 'modules/billing/store/collections/subscriptions'
import Plan from 'modules/billing/store/models/Plan'

const UpgradeModalPage = () => {
  const {
    company: { subscription: currentSubscription },
  } = useCurrentSession()
  const { navigation } = useNavigation()
  const navigate = useNavigate()

  const index = navigation.upgradePlan.fullPath()
  const subscription = subscriptions.current
  const currentPlan = subscriptionPlan(subscription)
  const planToUpgradeName = planToUpgrade(currentSubscription.planFamily)

  useUnsafeEffect(() => {
    if (!planToUpgrade || !currentPlan) {
      navigate(index)
    }
  }, [planToUpgradeName, navigate, index, currentPlan])

  const onClose = () => {
    navigate(index)
  }

  if (!planToUpgradeName || !currentPlan) return null

  const interval = currentPlan.isYearly ? Plan.intervals.year : Plan.intervals.month

  return <UpgradeModal onClose={onClose} family={planToUpgradeName} interval={interval} />
}

export default UpgradeModalPage
